import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { FAQSection } from "@/components/sections/FAQSection";

export default function FAQPage() {
  return (
    <main>
      <PageHeader eyebrow="FAQ" title="Frequently asked questions." lead="Everything about donations, volunteering, transparency and partnerships." />
      <FAQSection />
    </main>
  );
}
